import { render } from "./GridComponentFolder.vue?vue&type=template&id=dee768d0"
import script from "./GridComponentFolder.vue?vue&type=script&lang=js"
export * from "./GridComponentFolder.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__